import axios from "axios";
import { setError, isValidErrorsArray } from "~/utils/service-error-handling";
import { getProperty } from "dot-prop";
import { deepHasAnyKey } from "~/utils/deep-object-and-array";

const errorFormatsConfig = {
  errorsArrayConfigs: [
    {
      lookIn: "data",
      errorsArrayProperty: ["errors", "messages"],
      errorCodeProperty: ["errorCode"],
      errorMessageProperty: ["errorMessage"],
    },
    {
      errorsArrayProperty: ["errors"],
      errorCodeProperty: ["extensions.code"],
      errorMessageProperty: ["message"],
    },
  ],
};

const setErrorsMethods = {
  errorsArrayConfigs(response, config) {
    const responseData = response.data;

    config.forEach(
      ({
        lookIn,
        errorsArrayProperty,
        errorCodeProperty,
        errorMessageProperty,
      }) => {
        const lookInObj = lookIn
          ? getProperty(responseData, lookIn)
          : responseData;

        const errorsArray = deepHasAnyKey(lookInObj, errorsArrayProperty)
          ?.value;

        if (!isValidErrorsArray(errorsArray)) return;

        errorsArray.forEach((errorObj) =>
          setError(
            responseData,
            deepHasAnyKey(errorObj, errorCodeProperty)?.value,
            deepHasAnyKey(errorObj, errorMessageProperty)?.value
          )
        );
      }
    );
  },
};

function setErrorsFromConfig(response) {
  let hasError = false;
  Object.entries(errorFormatsConfig).forEach(([key, config]) => {
    let hasErrorSetted = setErrorsMethods[key](response, config);
    hasError = hasError || hasErrorSetted;
  });
  return hasError;
}

function checkSetErrors(response) {
  if (!response?.data || response.config.serviceConfig?.type != "graphql")
    return;

  setErrorsFromConfig(response);
}

export default function () {
  axios.interceptors.response.use(
    function (response) {
      checkSetErrors(response);
      return response;
    },
    function (error) {
      checkSetErrors(error.response);
      throw error;
    }
  );
}
